var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormPageAdPlacement", {
                attrs: {
                  data: _vm.adPlacement,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                },
                on: {
                  submit: _vm.fromAdPlacementSubmit,
                  "delete-ad-placement": _vm.deleteAdPlacement,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmAdPlacementRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }